import { render } from "./all-court.vue?vue&type=template&id=d896dc3c"
import script from "./all-court.vue?vue&type=script&lang=js"
export * from "./all-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__